import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { fetchRequestWrapper } from "@/lib/utilities";
import tradeBlockDataStore, { IBlockAssigned } from "./tradeBlockDataStore";
import tradeDataStore from "./tradeDataStore";

// ------- ENDPOINT TO GET BLOCK DATA -------
export async function getBlocksData({
  esid,
  getAccessTokenSilently,
}: {
  esid: string;
  getAccessTokenSilently: Function;
}) {
  const currentBlockTradeData = tradeBlockDataStore.getState().tradeBlockData;

  const getBlocksResponse = await fetchRequestWrapper(
    { url: "/Blocks/Assigned/" + esid },
    getAccessTokenSilently,
  );

  const responseBlocks: IBlockAssigned[] = Array.isArray(getBlocksResponse.blocks)
    ? getBlocksResponse.blocks
    : [];

  let isValueInArray = false;

  const newBlockData = currentBlockTradeData.map(
    (trade): { esid: string; blocks: IBlockAssigned[] } => {
      if (trade.esid !== esid) {
        return trade;
      } else {
        isValueInArray = true;
        return {
          ...trade,
          blocks: responseBlocks.map((block: IBlockAssigned) => ({
            ...block,
            esid: esid,
          })),
        };
      }
    },
  );

  if (!isValueInArray) {
    newBlockData.push({
      esid: esid,
      blocks: responseBlocks.map((block: IBlockAssigned) => ({
        ...block,
        esid: esid,
      })),
    });
  }

  tradeBlockDataStore.getState().updateTradeBlockData(newBlockData);

  // TODO: Currently still initalising the data on the action summary.
  // Also need to update the tradeDataStore to get a base level to pass to the params of the table for the initial table row creation.
  const currentTradeData = tradeDataStore.getState().tradeData;

  const newTradeDataWithBlocks = currentTradeData.map(
    (trade): ExecutionStrategy => {
      if (trade.esid !== esid) {
        return trade;
      } else {
        return {
          ...trade,
          blocks: responseBlocks.map((block: IBlockAssigned) => ({
            ...block,
            esid: esid,
          })),
        };
      }
    },
  );
  tradeDataStore.getState().updateTradeData(newTradeDataWithBlocks);
}

export async function updateBlockInfoESID(
  esid: string,
  getAccessTokenSilently: Function,
) {
  const currentTradeBlockData = tradeBlockDataStore.getState().tradeBlockData;

  const blocksAssignedResponse = await fetchRequestWrapper(
    { url: "/Blocks/Assigned/" + esid },
    getAccessTokenSilently,
  );

  const responseBlocks: IBlockAssigned[] = Array.isArray(blocksAssignedResponse.blocks)
    ? blocksAssignedResponse.blocks
    : [];

  const newTradeData = currentTradeBlockData.map((group) => {
    if (group.esid == esid) {
      return {
        ...group,
        blocks: responseBlocks.map((block: IBlockAssigned) => ({
          ...block,
          esid: esid,
        })),
      };
      // return { esid: esid, blocks: [...blocksAssignedResponse.blocks] };
    }
    return group;
  });
  const currentEsids = tradeDataStore.getState().eisdsToFlash; // If we want to flash esid row on trade data
  if (!currentEsids.includes(esid)) {
    tradeDataStore.getState().updateEisdsToFlash([...currentEsids, esid]); // If we want to flash esid row on trade data
  }
  tradeBlockDataStore.getState().updateTradeBlockData(newTradeData);
}
